import { render, staticRenderFns } from "./DoiBadge.vue?vue&type=template&id=8916449c&"
import script from "./DoiBadge.vue?vue&type=script&lang=ts&"
export * from "./DoiBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports